import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const digitsOnly = (value) => (value || "").replace(/[^\d]/g, "");

/** Turns a UK number into the international form WhatsApp expects. */
export const waNumber = (value) => {
  const digits = digitsOnly(value);
  if (!digits) return "";
  if (digits.startsWith("44")) return digits;
  return `44${digits.replace(/^0+/, "")}`;
};

const MESSAGE = encodeURIComponent(
  "Hello Procure Group, I would like to ask about a damp problem at my property.");

/** Always-on WhatsApp button for public pages. Hidden until a number is configured in Settings. */
export default function WhatsAppButton({ desktopOnly = false }) {
  const [number, setNumber] = useState("");

  useEffect(() => {
    api.get("/site/settings")
      .then(({ data }) => setNumber(waNumber(data.whatsapp)))
      .catch(() => {});
  }, []);

  if (!number) return null;

  return (
    <a
      href={`https://wa.me/${number}?text=${MESSAGE}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Message Procure Group on WhatsApp"
      data-testid="whatsapp-button"
      style={{
        bottom: "calc(var(--pg-consent-height, 0px) + var(--pg-actionbar-height, 0px) + 1.25rem)",
      }}
      className={`group fixed right-4 z-40 ${desktopOnly ? "hidden md:flex" : "flex"} h-14 w-14 items-center justify-center
                 rounded-full bg-[#25D366] shadow-lg shadow-black/20 transition-transform
                 hover:scale-105 focus-visible:outline focus-visible:outline-2
                 focus-visible:outline-offset-2 focus-visible:outline-[#128C7E]
                 md:right-6 md:h-16 md:w-16`}
    >
      <span className="pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap rounded-md
                       bg-pg-dark px-3 py-2 text-xs font-semibold text-white opacity-0 transition-opacity
                       group-hover:opacity-100 md:block">
        Message us on WhatsApp
      </span>
      <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white md:h-8 md:w-8" aria-hidden="true">
        <path d="M16.04 4C9.96 4 5.02 8.94 5.02 15.02c0 2.12.6 4.1 1.64 5.78L5 28l7.4-1.94a11 11 0 0 0 3.64.62c6.08 0 11.02-4.94 11.02-11.02S22.12 4 16.04 4Zm0 20.06c-1.2 0-2.38-.24-3.46-.7l-.42-.18-4.02 1.06 1.08-3.92-.22-.42a8.96 8.96 0 0 1-1.06-4.24c0-4.98 4.06-9.04 9.06-9.04s9.04 4.06 9.04 9.04c0 5-4.04 9.36-9 9.36Zm5.12-6.74c-.28-.14-1.64-.8-1.9-.9-.26-.1-.44-.14-.62.14-.18.28-.72.9-.88 1.08-.16.18-.32.2-.6.06a7.36 7.36 0 0 1-2.16-1.34 8.16 8.16 0 0 1-1.5-1.86c-.16-.28-.02-.44.12-.58.14-.14.32-.36.48-.54.12-.14.18-.26.28-.44.1-.18.04-.34-.02-.48-.06-.14-.62-1.5-.86-2.04-.22-.54-.44-.46-.6-.46h-.52c-.18 0-.46.06-.7.32-.24.26-.92.9-.92 2.2 0 1.3.94 2.56 1.08 2.74.14.18 1.86 2.96 4.52 4.04 2.66 1.08 2.66.72 3.14.68.48-.04 1.56-.64 1.78-1.26.22-.62.22-1.16.16-1.26-.06-.1-.22-.16-.5-.3Z" />
      </svg>
    </a>
  );
}
